<template>
  <div class="pop-up--form card card--lg" id="order-modal">
    <order-address v-if="step === 'ADDRESS'"></order-address>
    <order-address-fail v-if="step === 'ADDRESS-FAIL'"></order-address-fail>

    <order-oneoff-new v-if="step === 'NEW' && isRecurring === false"></order-oneoff-new>
    <order-oneoff-summary v-if="step === 'SUMMARY' && isRecurring === false"></order-oneoff-summary>

    <order-recurring-edit v-if="step === 'NEW' && isRecurring === true"></order-recurring-edit>
    <order-recurring-summary v-if="step === 'SUMMARY' && isRecurring === true"></order-recurring-summary>

    <order-payment v-if="step === 'PAYMENT'"></order-payment>
    <order-congrats v-if="step === 'CONGRATS'"></order-congrats>
  </div>
</template>

<script>
export default {
  props: ['products', 'halfDays', 'user', 'type'],

  data() {
    return {
      step: 'NEW',
      date: null,
      slot: "",
      slots: [],
      cart: {},
      items: [],
      total: null,
      itemsTotal: null,
      adjustments: [],
      products: this.products,
      user: this.user,
      order: null,
      loading: false,
      method: 'HAND_TO_HAND',
      isRecurring: false,
      isGift: false,
      note: null,
      hasNote: false,
      promotion_total: null,
      promotion_code: null,
      promotionErrors: [],
      address: {},
      addressHasChanged: false,
    }
  },

  beforeMount() {
    this.order = this.$parent.newOneOff;
    this.isGift = false;

    if (this.$parent.newGift) {
      this.order = this.$parent.newGift;
      this.isGift = true;
      this.step = 'ADDRESS';
    }

    if (this.type === 'RECURRING') {
      this.order = this.$parent.generatedRecurring;
    }

    const { postcode } = this.user.shipping_address;

    this.address = {
      postcode,
    }

    // Set order datas if exists
    if (typeof this.order == 'object') {
      this.isRecurring = this.order.type === 'RECURRING';

      this.date = this.$options.filters.dateFormat(this.order.date_delivery);

      this.getSlots(this.date);
      this.slot = this.order.time_slot.id;

      const promotionAdjustment = this.order.adjustments.find((e) => e.type === "ORDER_PROMOTION");
      if (promotionAdjustment) {
        this.promotion_total = promotionAdjustment.amount;
        this.promotion_code = promotionAdjustment.origin_code;
      }

      this.note = this.order.note;
      if (this.order.note) {
        this.hasNote = true;
      }

      this.address = {
        ...this.order.shipping_address,
        firstname: this.order.customer_firstname,
        lastname: this.order.customer_lastname,
      }
    }

    // Set cart with products
    this.products.forEach((element) => {
      this.cart[element.id] = element;
      Vue.set(this.cart[element.id], 'qty', 0);
      Vue.set(this.cart[element.id], 'base_qty', 0);

      // Set product qty if order exists
      if (typeof this.order == 'object') {
        let extraProduct = null;
        let orderItem = this.order.items.find((i) => i.product_id === element.id);

        //Vue.set(this.cart[element.id], 'qty', item.qty);

        if (this.isRecurring) {
          extraProduct = this.order.extra_products.find((i) => i.product_id === element.id);

          if (extraProduct) {
            Vue.set(this.cart[element.id], 'base_qty', orderItem.qty - extraProduct.qty);
            Vue.set(this.cart[element.id], 'qty', extraProduct.qty);
          }
          else if (orderItem) {
            Vue.set(this.cart[element.id], 'base_qty', orderItem.qty);
          }
        }
        else if (orderItem)  {
          Vue.set(this.cart[element.id], 'qty', orderItem.qty);
        }
      }
    });
  },

  methods: {

    getSlots(date, isNew) {
      axios.post("/api/timeslot/date", {
        date: date,
        postcode: this.address.postcode
      }).then(res => {
        this.slots = res.data.datas;

        this.slots = this.slots.filter((slot) => {
          return this.halfDays.find(((halfDay) => {
            let selectedDate = moment(date, 'DD/MM/YYYY').toDate();
            let startAt = new Date(halfDay.pivot.start_at);
            startAt.setHours(0);
            startAt.setMinutes(0);
            startAt.setSeconds(0);
            return halfDay.id === slot.half_day_id && selectedDate >= startAt;
          }));
        });

        //if (isNew && this.slots.length) {
        //    this.slot = this.slots[0].slot;
        //}
      }).catch(error => console.log(error));
    },

    updateProductsPeriodAvailability(date) {
      this.products.map((product) => {
        product.can_sale = false;
        if (product.is_tracked) {
          if (this.cart) {
            let item = Object.values(this.cart).filter(i => product.id === i.id);
            if (item.length) {
              item = item.shift();
              product.stock += item.qty;
              product.can_sale = true;
            }
          }
        }

        if (product.start_sale && date.toISOString() < new Date(product.start_sale).toISOString()) {
          product.can_sale = false;
          product.qty = 0;
        }
        else if (product.end_sale && new Date(product.end_sale).toISOString() < date.toISOString()) {
          product.can_sale = false;
          product.qty = 0;
        }
        else {
          product.can_sale = true;
        }
      });
    },

    sendOrder(card = null) {
      this.loading = true;
      this.promotionErrors = [];

      if (this.loading) {
        if (this.isGift) {
          this.address = {
            ...this.address,
            firstname: this.address.firstname,
            lastname: this.address.lastname,
          }
        }

        // Order
        axios.post("/api/order", {
          order_id: this.order ? this.order.id : null,
          customer_id: this.$root.user.id,
          date_delivery: this.date,
          time_slot_id: this.slot,
          order_items: this.items,
          type: 'ONE_OFF',
          token: this.$root.user.password,
          card: JSON.stringify(card),
          from: this.$root.from,
          promotion_code: this.promotion_code,
          is_gift: this.isGift,
          note: this.note,
          address: this.isGift ? this.address : null,
        }).then(res => {
          this.loading = false;

          if (res.data.success === false) {
            this.promotionErrors = res.data.datas.message.split('. ');
          } else {
            if (typeof gtag_report_conversion === "function") {
              gtag_report_conversion();
            }
            if (typeof fbq === "function") {
              fbq('track', 'Purchase');
            }
            // Show congrats popup
            this.step = 'CONGRATS';

            // Update datas
            if (this.$root.from === 'DASHBOARD') {
              this.$root.orders.oneOff = res.data.datas;
            } else {
              this.$root.orders.upcoming = res.data.datas;
            }

          }
        }).catch((error) => {
          let message = '';
          Object.keys(error.response.data.errors).map(function(key) {
            message += error.response.data.errors[key] + ' ';
          });
          this.$root.alert = {
            type: "ERROR",
            title: "Oops...",
            text: message
          };
          this.loading = false;
        });
      }

      return false;
    },

    validateOrder() {
      this.loading = true;
      this.items = [];
      this.promotionErrors = [];

      // Set cart items
      $.each(this.cart, (index, product) => {
        if (product.qty > 0) {
          this.items.push({
            product_id: product.id,
            qty: product.qty
          });
        }
      });

      let orderItems = [];
      if (this.isRecurring) {
        const initialItems = this.order.items.map((item) => {
          if (this.order.extra_products.find((i) => i.product_id === item.product_id)) {
            return {
              product_id: item.product_id,
              qty: item.qty - this.order.extra_products.find((i) => i.product_id === item.product_id).qty
            };
          }
          else {
            return item;
          }
        });

        orderItems = this.items.map((item) => {
          if (initialItems.find((i) => i.product_id === item.product_id)) {
            return {
              product_id: item.product_id,
              qty: item.qty + initialItems.find((i) => i.product_id === item.product_id).qty
            };
          }
          else {
            return item;
          }
        });
      }
      else {
        orderItems = this.items;
      }

      return axios.post("/api/order/validate", {
        order_id: this.order ? this.order.id : null,
        customer_id: this.$root.user.id,
        date_delivery: this.date,
        time_slot_id: this.slot,
        order_items: orderItems,
        type: this.isRecurring ? 'RECURRING' : 'ONE_OFF',
        token: this.$root.user.password,
        from: this.$root.from,
        promotion_code: this.promotion_code,
        note: this.note,
        address: this.address,
      }).then(res => {
        this.loading = false;

        if (res.data.success === false) {
          this.promotionErrors = res.data.datas.message.split('. ');
        } else {
          const promotionAdjustment = res.data.datas.adjustments.find((e) => e.type === "ORDER_PROMOTION");
          if (promotionAdjustment) {
            this.promotion_total = promotionAdjustment.amount;
            this.promotion_code = promotionAdjustment.origin_code;
          }

          this.total = res.data.datas.total;
          this.itemsTotal = res.data.datas.items_total;
          this.adjustments = res.data.datas.adjustments;
        }
      }).catch((error) => {
        let message = '';
        Object.keys(error.response.data.errors).map(function(key) {
          message += error.response.data.errors[key] + ' ';
        });
        this.$root.alert = {
          type: "ERROR",
          title: "Oops...",
          text: message
        };
        this.loading = false;
      });
    },
  },

  computed: {
    humanized_slot() {
      if (this.slots.length) {
        return this.slots.find((slot) => slot.id === this.slot).humanized_slot;
      }
      return null;
    },
  }
}
</script>
